import equal from 'fast-deep-equal';
import { create } from 'zustand';

import { GetEmailTemplate } from '../api';

type EmailTemplate = NonNullable<GetEmailTemplate['return']>[0];

type UseSelectedEmailTemplateStore = {
  selectedEmailTemplate: EmailTemplate | null;
  updateSelectedEmailTemplate: (newTemplate: EmailTemplate) => void;
  resetSelectedEmailTemplate: () => void;
  hasChanged: (newTemplate: EmailTemplate) => boolean;
};

const useSelectedEmailTemplateStore = create<UseSelectedEmailTemplateStore>(
  (set, get) => ({
    selectedEmailTemplate: null,

    updateSelectedEmailTemplate: (newTemplate) =>
      set({ selectedEmailTemplate: newTemplate }),

    resetSelectedEmailTemplate: () => set({ selectedEmailTemplate: null }),

    hasChanged: (newTemplate) =>
      !equal(get().selectedEmailTemplate, newTemplate),
  }),
);

export const useSelectedEmailTemplate = () =>
  useSelectedEmailTemplateStore((state) => state.selectedEmailTemplate);

export const updateSelectedEmailTemplate = (newTemplate: EmailTemplate) =>
  useSelectedEmailTemplateStore
    .getState()
    .updateSelectedEmailTemplate(newTemplate);

export const resetSelectedEmailTemplate = () =>
  useSelectedEmailTemplateStore.getState().resetSelectedEmailTemplate();

export const hasEmailTemplateChanged = (newTemplate: EmailTemplate) =>
  useSelectedEmailTemplateStore.getState().hasChanged(newTemplate);
